interface InstallationData {
  restaurantId: string;
  timestamp: number;
  userAgent: string;
  platform: string;
}

export const trackPWAInstallation = async (
  restaurantId: string
): Promise<void> => {
  try {
    const installationData: InstallationData = {
      restaurantId,
      timestamp: Date.now(),
      userAgent: navigator.userAgent,
      platform: navigator.platform,
    };

    // You can implement your tracking logic here:
    // 1. Send to analytics service
    await sendToAnalytics(installationData);

    // 2. Store in local database
    storeInstallationLocally(installationData);

    // 3. Log for debugging
    console.log("PWA Installation tracked:", installationData);
  } catch (error) {
    console.error("Failed to track PWA installation:", error);
  }
};

// Example analytics sender function
const sendToAnalytics = async (data: InstallationData): Promise<void> => {
  // Replace with your actual analytics endpoint
  const ANALYTICS_ENDPOINT = "/api/track-pwa-installation";

  try {
    const response = await fetch(ANALYTICS_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(
        `Analytics request failed with status ${response.status}`
      );
    }
  } catch (error) {
    console.error("Failed to send analytics:", error);
    // You might want to queue failed analytics requests for retry
  }
};

// Example local storage function
const storeInstallationLocally = (data: InstallationData): void => {
  try {
    const installations = JSON.parse(
      localStorage.getItem("pwaInstallations") || "[]"
    );

    installations.push(data);
    localStorage.setItem("pwaInstallations", JSON.stringify(installations));
  } catch (error) {
    console.error("Failed to store installation data locally:", error);
  }
};
